import InfoIcon from 'components/icons/InfoIcon';
import Tooltip from 'components/common/tooltip/tooltip';
import { Button } from 'components/common/button/button';
import { useModal } from 'components/modal-views/context';

import { useAppDispatch, useAppSelector } from 'redux/use-hooks';
import { actions as tokensSliceActions } from 'redux/slices/tokens';
import { selectStorageBalance } from 'redux/slices/account';
import selectNEARAsTokenWithMetadata from 'redux/selectors/crossStateSelectors/selectNEARAsTokenWithMetadata';
import { formatToken } from 'components/wallet/token-amount';
import config from 'config';

const { setActiveToken } = tokensSliceActions;

import {
  StyledFlex,
  StyledStorageInfo,
  StyledLabelWrapper,
  StyledLabel,
  StyledValue,
  StyledButtons,
} from './storage-info.style';

const { OCC_CONTRACT } = config;

const StorageInfo = () => {
  const dispatch = useAppDispatch();
  const { openModal } = useModal();
  const nearTokenBalance = useAppSelector(selectNEARAsTokenWithMetadata);
  const storageBalance = useAppSelector(selectStorageBalance);
  const occStorageBalance = storageBalance[OCC_CONTRACT];

  const handleOpenModal = (type) => {
    dispatch(setActiveToken(nearTokenBalance));
    openModal(type);
  };

  return (
    <StyledFlex>

      <StyledStorageInfo>
        <StyledLabelWrapper>
          <StyledLabel>Storage Deposit</StyledLabel>
          <Tooltip
            isMultiline
            message={`
              NEAR requires a storage deposit fee to own OCCs in your wallet. <br />
              A storage deposit of 1 NEAR should be sufficient for most users. <br />
              If you attempt to send OCCs to a user who has an insufficient storage <br />
              deposit, the transaction will fail. You can first send them NEAR for their <br />
              storage deposit through the "Storage Deposit" tab, then send the OCCs.
            `}
          >
            <InfoIcon color="#fabc73" />
          </Tooltip>
        </StyledLabelWrapper>
        <StyledValue>{formatToken(occStorageBalance.available, 24)} NEAR</StyledValue>
      </StyledStorageInfo>

      <StyledButtons>
        <Button
          variant="outlined"
          size="middle"
          fullwidth
          onClick={() => handleOpenModal('INCREASE_STORAGE')}
        >
          Increase
        </Button>
        <Button
          variant="outlined"
          size="middle"
          fullwidth
          onClick={() => handleOpenModal('WITHDRAW_STORAGE')}
        >
          Withdraw
        </Button>
      </StyledButtons>

    </StyledFlex>
  );
};

export default StorageInfo;
